var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[(_vm.dataLabel)?_c('h5',{staticClass:"text-muted"},[_vm._v("\n        "+_vm._s(_vm.dataLabel)+"\n    ")]):_vm._e(),_c('div',{staticClass:"box-wrapper",style:({width: _vm.dataWidth})},[(_vm.dataIcon)?_c('i',{staticClass:"mdi",class:_vm.dataIcon}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }